
    import './styles.scoped.css';
    export default {
  "dropdown-content-wrapper": "awsui_dropdown-content-wrapper_qwoo0_1632s_93",
  "awsui-motion-fade-in-dropdown": "awsui_awsui-motion-fade-in-dropdown_qwoo0_1632s_1",
  "refresh": "awsui_refresh_qwoo0_1632s_114",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_qwoo0_1632s_1",
  "root": "awsui_root_qwoo0_1632s_143",
  "interior": "awsui_interior_qwoo0_1632s_179",
  "dropdown": "awsui_dropdown_qwoo0_1632s_93",
  "use-portal": "awsui_use-portal_qwoo0_1632s_190",
  "is-empty": "awsui_is-empty_qwoo0_1632s_243",
  "dropdown-drop-up": "awsui_dropdown-drop-up_qwoo0_1632s_246",
  "with-limited-width": "awsui_with-limited-width_qwoo0_1632s_250",
  "dropdown-drop-left": "awsui_dropdown-drop-left_qwoo0_1632s_253",
  "dropdown-drop-right": "awsui_dropdown-drop-right_qwoo0_1632s_256",
  "occupy-entire-width": "awsui_occupy-entire-width_qwoo0_1632s_259",
  "stretch-beyond-trigger-width": "awsui_stretch-beyond-trigger-width_qwoo0_1632s_262",
  "hide-upper-border": "awsui_hide-upper-border_qwoo0_1632s_266",
  "open": "awsui_open_qwoo0_1632s_273",
  "nowrap": "awsui_nowrap_qwoo0_1632s_282",
  "dropdown-content": "awsui_dropdown-content_qwoo0_1632s_93",
  "stretch-trigger-height": "awsui_stretch-trigger-height_qwoo0_1632s_293"
};
  